import { Stack, Typography } from "@mui/material"
import { Case, Switch } from "lib/@components/switch"
import { LocalizedMessage } from "lib/localization/localized-message"

/**
 * Tooltip content for task duration (NaN / short with seconds / rounded minutes only).
 *
 * @param {object} props
 * @param {number} props.minutes
 * @param {number} props.seconds
 * @param {number} props.rounded
 */
export function TimeDurationTooltipBody({ minutes, seconds, rounded }) {
    const variant = Number.isNaN(minutes) ? "nan" : seconds !== 0 ? "short" : "long"

    return (
        <Switch value={variant}>
            <Case when="nan">
                <LocalizedMessage template="Duration not specified" />
            </Case>
            <Case when="short">
                <Stack>
                    <Typography variant="caption" component="div">
                        <LocalizedMessage template="Estimated Task Duration" />
                    </Typography>
                    <Typography variant="body2" component="div">
                        <LocalizedMessage
                            template="{minutes} minutes {seconds} seconds"
                            values={{ minutes, seconds }}
                        />
                    </Typography>
                </Stack>
            </Case>
            <Case when="long">
                <Stack>
                    <Typography variant="caption" component="div">
                        <LocalizedMessage template="Estimated Task Duration" />
                    </Typography>
                    <Typography variant="body2" component="div">
                        <LocalizedMessage template="{totalMinutes} minutes" values={{ totalMinutes: rounded }} />
                    </Typography>
                </Stack>
            </Case>
        </Switch>
    )
}
